import { SiGooglenews } from "react-icons/si";
import { type SocialPlatformBaseSettings } from "./types";

export const googlebusinessBaseSettings: SocialPlatformBaseSettings = {
  name: "Google Business",
  icon: SiGooglenews,
  fields: {
    // Title is handled via specific post types (Event, Offer)
    caption: "required", // The main body/description
    linkAttachment: "optional", // CTA button link
  },
  limits: {
    caption: 1500, // Ideal 150-300
    images: 1,
    videos: 1,
    videoDurationSeconds: 30,
  },
  notes: [
    "Ideal caption length: 150-300 characters.",
    "Only first ~100 chars visible before click.",
    "Use specific post types (Event, Offer, Update) via GMB interface/API for titles.",
  ],
  postTypes: {
    update: {}, // Standard update post
    // Add 'event' and 'offer' types if needed, they have more specific fields (title, dates etc)
  },
};
